<template>
  <Multiselect
    v-model="value[filterKey]"
    :options="choices"
    :label="options?.label"
    variant="narrow"
  />
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import Multiselect from '@components/utils/Multiselect.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export interface Options {
  label?: string;
  labelTrue?: string;
  labelFalse?: string;
}

export interface Props {
  modelValue: Record<string, boolean>;
  filterKey: string;
  options: Options;
}

const { t } = useI18n();

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });

const choices = computed(() => [
  {
    label: props.options?.labelTrue ?? t('yes'),
    value: true,
  },
  {
    label: props.options?.labelFalse ?? t('no'),
    value: false,
  },
]);
</script>

<style lang="scss" scoped></style>
